import { sleep } from "../../utils/timers";
import { CallbackFnType, Task } from "../types";



// eslint-disable-next-line @typescript-eslint/no-empty-function
export const emptyFunc = (): void => { };

export const notifyStatusChange = async <T = unknown>(
  task: Task,
  type: CallbackFnType,
  message?: string,
  data?: T
): Promise<void> => {
  await sleep(0);
  task.callback(type, task.taskId, message, data);
};

export const renderReadableStreamArrayBuffer = async (stream: NodeJS.ReadableStream): Promise<ArrayBuffer> => {
  return new Promise((resolve, reject) => {
    const chunks: Buffer[] = [];
    stream.on("data", (data) => chunks.push(data));
    stream.on("end", () => {
      resolve(Buffer.concat(chunks));
    });
    stream.on("error", reject);
  });
};